"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EmailVerificationRequestDto = void 0;
const swagger_1 = require("@nestjs/swagger");
class EmailVerificationRequestDto {}
exports.EmailVerificationRequestDto = EmailVerificationRequestDto;
__decorate([(0, swagger_1.ApiProperty)({
  description: "The verification token sent to the user's email",
  example: '123e4567-e89b-12d3-a456-426614174000'
}), __metadata("design:type", String)], EmailVerificationRequestDto.prototype, "token", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'The email address to verify',
  example: 'user@example.com'
}), __metadata("design:type", String)], EmailVerificationRequestDto.prototype, "email", void 0);
//# sourceMappingURL=EmailVerificationRequest.dto.js.map